const STEPS = [
  {
    n: "01",
    title: "The second opinion",
    body: "Hire us by the hour for an independent review — security checks, SEO effectiveness, code quality, whatever’s at risk. Like an inspection, you get a straight answer before you spend real money.",
  },
  {
    n: "02",
    title: "Your programmer",
    body: "Like what you see? Keep us on call. We become the programmer your company turns to — the shop you always go back to.",
  },
  {
    n: "03",
    title: "Off-the-shelf tools",
    body: "Ready to stop paying by the hour for routine work? Pick from packages built once and priced per use: eContract, Invoice, and Loan Onboarding.",
  },
] as const;

export function Ladder() {
  return (
    <section id="how" className="k-band k-band--paper">
      <div className="k-shell k-sec">
        <p className="k-label">The relationship</p>
        <h2>Three ways we work with you</h2>
        <p className="k-sub">
          It starts with an hour and grows from there — the same way you’d come
          to trust a mechanic.
        </p>

        <div className="k-steps">
          {STEPS.map((step) => (
            <article key={step.n} className="k-step">
              <span className="k-step__n">{step.n}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
